import { z } from 'zod';
// Brand content plan — spec §0b. Mag's perpetual content plan for
// one brand channel. Replaces the content-plan fields that used to
// live in campaigns.draft with kind='organic_meta'.
//
// Shape mirrors today's MetaContentPlanOutput so the meta-content-
// plan agent can be retargeted in Phase 0b.2 with minimal re-prompting.
export const brandContentPlanStatusSchema = z.enum(['active', 'superseded', 'archived']);
export const brandContentPlanGeneratedViaSchema = z.enum([
    'mag_initial',
    'mag_revise',
    'founder_edit',
    'migrated_from_campaign',
]);
/** Cadence shape. Common contract across channels; channel adapters
 *  may add channel-specific fields server-side. */
export const brandContentPlanCadenceSchema = z.object({
    postsPerWeek: z.number().int().min(1).max(21),
    /** ISO weekday → hour windows. e.g. { Mon: [[9,11],[17,19]] }. */
    windowsByWeekday: z.record(z.string(), z.array(z.tuple([z.number(), z.number()]))),
    /** Brand tz the cadence is expressed in. */
    tz: z.string().min(1).max(60),
});
/** A content pillar — mag's thematic anchor. Same shape pillars
 *  carry on the existing MetaContentPlanOutput. */
export const brandContentPlanPillarSchema = z.object({
    label: z.string().min(1).max(60),
    description: z.string().min(1).max(500),
    weightPercent: z.number().int().min(1).max(100),
});
export const brandContentPlanSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    brandId: z.string().uuid(),
    brandChannelId: z.string().uuid(),
    status: brandContentPlanStatusSchema,
    cadence: brandContentPlanCadenceSchema,
    pillars: z.array(brandContentPlanPillarSchema).min(1).max(8),
    summary: z.string().nullable(),
    generatedAt: z.string().datetime(),
    generatedVia: brandContentPlanGeneratedViaSchema,
    costCents: z.number().int().min(0),
    llmModelId: z.string().nullable(),
});
//# sourceMappingURL=brand-content-plan.js.map